import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import AdviceList from 'funnel/components/detail/advices/AdviceList';
import { toggleAdvice, removeAdvice } from 'funnel/actions/advice';

const mapStateToProps = state => ({
  advices: state.funnels.advices.items.toArray(),
});
const mapDispatchToProps = dispatch => ({
  toggleAdvice: advice => dispatch(toggleAdvice(advice)),
  removeAdvice: advice => dispatch(removeAdvice(advice)),
});
const FunnelAdvicesPage = ({ advices, toggleAdvice, removeAdvice }) => (
  <div>
    <AdviceList
      advices={advices}
      toggleAdvice={toggleAdvice}
      removeAdvice={removeAdvice}
    />
  </div>
);

FunnelAdvicesPage.propTypes = {
  advices: PropTypes.array.isRequired,
  toggleAdvice: PropTypes.func.isRequired,
  removeAdvice: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(FunnelAdvicesPage);



// WEBPACK FOOTER //
// ./src/modules/funnel/pages/FunnelAdvicesPage.js